import React from 'react';

import styles from './executiveManagementStyles';

import Executive from './Executive/executive';

const ExecutiveManagement = ({ fundProfile }) => {
  const { executives } = fundProfile;
  return (
    <div className={styles.executivesList}>
      {executives.map((executive, index) => (
        <Executive key={index} executive={executive} />
      ))}
    </div>
  );
};

export default ExecutiveManagement;
